module.exports = __webpack_public_path__ + "static/img/property.5517cb35.svg";